"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useProductQuestionCallCreate;

var _useServiceCallCreate = _interopRequireDefault(require("@sprinx/react-api-client/useServiceCallCreate"));

var _useDefaults = _interopRequireDefault(require("@sprinx/react-hooks/useDefaults"));

var _useResolveServiceActionName = _interopRequireDefault(require("@sprinx/react-api-client/useResolveServiceActionName"));

function useProductQuestionCallCreate(options) {
  return (0, _useServiceCallCreate.default)((0, _useDefaults.default)(options, {
    clientCode: 'api'
  }), (0, _useResolveServiceActionName.default)(null, 'v1.productQuestions.create'));
}